import _objectSpread from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import { Component } from "react";
var TRUNCATE_LENGTH = 1;
var Pager = /*#__PURE__*/function (_Component) {
  _inherits(Pager, _Component);
  var _super = _createSuper(Pager);
  function Pager() {
    var _this;
    _classCallCheck(this, Pager);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      currentPage: _this.props.defaultCurrentPage
    };
    _this.getPageProps = function (_ref, passPageProp) {
      var page = _ref.page,
        onClick = _ref.onClick,
        props = _objectWithoutProperties(_ref, ["page", "onClick"]);
      return _objectSpread({
        onClick: composeEventHandlers(onClick, function () {
          return _this.selectPage(page);
        }),
        page: passPageProp ? page : undefined
      }, props);
    };
    _this.selectPage = function (page) {
      if (_this.props.currentPage === undefined) {
        _this.setState({
          currentPage: page
        });
      }
      _this.props.onSelect && _this.props.onSelect(page);
    };
    return _this;
  }
  _createClass(Pager, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        totalPages = _this$props.totalPages,
        children = _this$props.children,
        _this$props$render = _this$props.render,
        render = _this$props$render === void 0 ? children : _this$props$render;
      if (!totalPages || totalPages <= 1) return null;
      var getPageProps = this.getPageProps,
        prevPage = this.prevPage,
        nextPage = this.nextPage,
        currentPage = this.currentPage,
        leftPages = this.leftPages,
        middlePages = this.middlePages,
        rightPages = this.rightPages,
        isFirstPage = this.isFirstPage,
        isLastPage = this.isLastPage,
        isLeftRangeTruncated = this.isLeftRangeTruncated,
        isRightRangeTruncated = this.isRightRangeTruncated;
      return render({
        getPageProps: getPageProps,
        prevPage: prevPage,
        nextPage: nextPage,
        currentPage: currentPage,
        totalPages: totalPages,
        leftPages: leftPages,
        middlePages: middlePages,
        rightPages: rightPages,
        isFirstPage: isFirstPage,
        isLastPage: isLastPage,
        isLeftRangeTruncated: isLeftRangeTruncated,
        isRightRangeTruncated: isRightRangeTruncated
      });
    }
  }, {
    key: "leftPages",
    get: function get() {
      var _this$props2 = this.props,
        marginPages = _this$props2.marginPages,
        totalPages = _this$props2.totalPages;
      var length = Math.min(marginPages, totalPages);
      return valuesFromRange(length);
    }
  }, {
    key: "middlePages",
    get: function get() {
      var _this$props3 = this.props,
        pageRange = _this$props3.pageRange,
        marginPages = _this$props3.marginPages,
        totalPages = _this$props3.totalPages;
      var currentPage = this.currentPage;
      if (this.shouldRangeBeTruncated) {
        if (this.isCurrentPageInLeftRange) {
          // 1 2 | 3 4 5 (6) _ | 14 15
          return valuesFromRange(pageRange - TRUNCATE_LENGTH, marginPages);
        } else if (this.isCurrentPageInRightRange) {
          // 1 2 _ (10) 11 12 13 | 14 15
          return valuesFromRange(pageRange - TRUNCATE_LENGTH, this.rightRange.begin);
        } else {
          // 1 2 | _ 7 (8) 9 _ | 14 15
          var length = pageRange - 2 * TRUNCATE_LENGTH;
          return valuesFromRange(length, currentPage - Math.ceil(length / 2));
        }
      } else {
        // 1 (2) || 3
        // 1 (2) || 3 4
        // 1 (2) | 3 | 4 5
        // 1 (2) | 3 4 5 6 7 | 8 9

        var _length = Math.max(totalPages - marginPages * 2, 0);
        return valuesFromRange(_length, marginPages);
      }
    }
  }, {
    key: "rightPages",
    get: function get() {
      var _this$props4 = this.props,
        totalPages = _this$props4.totalPages,
        marginPages = _this$props4.marginPages;
      var restPages = Math.max(totalPages - marginPages, 0);
      var length = Math.min(marginPages, restPages);
      return valuesFromRange(length, restPages);
    }
  }, {
    key: "isLeftRangeTruncated",
    get: function get() {
      return this.shouldRangeBeTruncated && !this.isCurrentPageInLeftRange;
    }
  }, {
    key: "isRightRangeTruncated",
    get: function get() {
      return this.shouldRangeBeTruncated && !this.isCurrentPageInRightRange;
    }
  }, {
    key: "shouldRangeBeTruncated",
    get: function get() {
      var _this$props5 = this.props,
        marginPages = _this$props5.marginPages,
        pageRange = _this$props5.pageRange,
        totalPages = _this$props5.totalPages;
      var maxPagesLength = marginPages * 2 + pageRange;
      return maxPagesLength < totalPages;
    }
  }, {
    key: "isCurrentPageInLeftRange",
    get: function get() {
      return this.currentPage <= this.leftRange.end - this.props.rangeOverlap;
    }
  }, {
    key: "isCurrentPageInRightRange",
    get: function get() {
      return this.currentPage > this.rightRange.begin + this.props.rangeOverlap;
    }
  }, {
    key: "prevPage",
    get: function get() {
      return this.isFirstPage ? 1 : this.currentPage - 1;
    }
  }, {
    key: "nextPage",
    get: function get() {
      return this.isLastPage ? this.props.totalPages : this.currentPage + 1;
    }
  }, {
    key: "isFirstPage",
    get: function get() {
      return this.currentPage === 1;
    }
  }, {
    key: "isLastPage",
    get: function get() {
      return this.currentPage === this.props.totalPages;
    }
  }, {
    key: "currentPage",
    get: function get() {
      return this.props.currentPage || this.state.currentPage;
    }
  }, {
    key: "leftRange",
    get: function get() {
      var _this$props6 = this.props,
        marginPages = _this$props6.marginPages,
        pageRange = _this$props6.pageRange;
      return {
        begin: 0,
        end: marginPages + pageRange - TRUNCATE_LENGTH
      };
    }
  }, {
    key: "rightRange",
    get: function get() {
      var _this$props7 = this.props,
        totalPages = _this$props7.totalPages,
        marginPages = _this$props7.marginPages,
        pageRange = _this$props7.pageRange;
      return {
        begin: totalPages - (marginPages + pageRange - TRUNCATE_LENGTH),
        end: totalPages
      };
    }
  }]);
  return Pager;
}(Component);
Pager.defaultProps = {
  defaultCurrentPage: 1,
  marginPages: 1,
  pageRange: 5,
  rangeOverlap: 1
};
export { Pager as default };
var valuesFromRange = function valuesFromRange(length) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Array.from({
    length: length
  }, function (_, index) {
    return offset + index + 1;
  });
};
var composeEventHandlers = function composeEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }
  return function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    return fns.some(function (fn) {
      fn && fn.apply(void 0, [event].concat(args));
      return event.defaultPrevented;
    });
  };
};